<script setup lang="ts">
  import { defineAsyncComponent, defineComponent, h } from 'vue';
  import ElLoadingPanel from '@/components/common/ElLoading/ElLoadingPanel.vue';
  import '@/styles/index.css';
  import { getBaseLanguage } from '@/utils/i18n';
  import { Locale, type TranslatableLabel } from '@/types/i18n.types';
  import { mergeMessages } from '@/i18n';

  mergeMessages('defaultMessages');

  const loadingLabels: TranslatableLabel = {
    [Locale.fr]: 'En chargement',
    [Locale.en]: 'Loading application',
  };

  const LoadingComponent = defineComponent(() => () => h(ElLoadingPanel, {
    label: loadingLabels[getBaseLanguage()],
    labelRenderingDelay: 0,
  }));

  const MonTransportAdapteApp = defineAsyncComponent({
    loader: () => import('./MonTransportAdapteApp.vue'),
    loadingComponent: LoadingComponent,
    delay: 200,
    suspensible: false,
  });

</script>

<template>
  <MonTransportAdapteApp />
</template>
